import React from "react";
import styles from "./GlowShape.module.scss";

export default function GlowShape(props) {
  const {colors = []} = props;

  return (
    <svg
      version="1.1"
      viewBox="0 0 100 100"
      width="100%"
      height="100%"
      preserveAspectRatio="xMinYMin meet"
      className={`${styles.svgContainer}`}>
      {colors?.map((c, index) => {
        return (
          <ellipse
            key={index}
            cx="50%"
            cy="50%"
            rx="60%"
            ry="85%"
            fill={
              c === "blue"
                ? "url(#blueDarkGlow)"
                : c === "red"
                ? "url(#redGlow)"
                : c === "green"
                ? "url(#greenGlow)"
                : c === "yellow"
                ? "url(#yellowGlow)"
                : c === "purple" && "url(#purpleDarkGlow)"
            }
            style={{transform: "rotate(55deg)", transformOrigin: "center"}}
          />
        );
      })}
    </svg>
  );
}
